import React from 'react'

function RightThreeDot(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34.11" height="61.944" viewBox="0 0 34.11 61.944" {...props}>
      <g data-name="Group 52000" transform="rotate(-171 607.782 235.918)">
        <circle
          cx="4.181"
          cy="4.181"
          r="4.181"
          fill="#d3dade"
          data-name="Ellipse 1026"
          transform="translate(1223.103 314.602)"
        ></circle>
        <circle
          cx="4.181"
          cy="4.181"
          r="4.181"
          fill="#fe5f55"
          data-name="Ellipse 1027"
          transform="translate(1208.093 350.604)"
        ></circle>
        <circle
          cx="2.508"
          cy="2.508"
          r="2.508"
          fill="#d3dade"
          data-name="Ellipse 1025"
          transform="translate(1239.194 368.959)"
        ></circle>
      </g>
    </svg>
  )
}

export default RightThreeDot
